const dramaCards = [
  {
    id: 1,
    title: '长风渡',
    category: '古装商战',
    cast: '白敬亭 / 宋轶',
    description: '商贾之女柳玉茹与纨绔子弟顾九思，阴差阳错结为夫妻，从相互抵触到相互扶持的传奇故事。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20costume%20drama%20poster%20style%2C%20couple%20in%20traditional%20Tang%20dynasty%20attire%20standing%20beside%20a%20river%20at%20sunset%2C%20soft%20golden%20light%2C%20romantic%20atmosphere%2C%20ancient%20Chinese%20merchant%20town%20background%2C%20cinematic%20composition%2C%20warm%20and%20elegant%20color%20palette&width=400&height=560&seq=card-drama-01-changfengdu&orientation=portrait',
    badge: '热播中',
  },
  {
    id: 2,
    title: '玉骨遥',
    category: '仙侠玄幻',
    cast: '肖战 / 任敏',
    description: '孤高清冷的空桑世子时影与热情仗义的赤族郡主朱颜，因一花之恩结下命劫夙缘。',
    image: 'https://readdy.ai/api/search-image?query=Mystical%20Chinese%20fantasy%20drama%20poster%20style%2C%20ethereal%20figures%20in%20flowing%20white%20robes%20floating%20among%20clouds%20and%20jade%20mountains%2C%20moonlight%20illuminating%20ancient%20temple%2C%20dreamy%20and%20romantic%20atmosphere%2C%20soft%20blue%20and%20white%20tones%20with%20golden%20accents&width=400&height=560&seq=card-drama-02-yuguyao&orientation=portrait',
    badge: '高分推荐',
  },
  {
    id: 3,
    title: '莲花楼',
    category: '武侠悬疑',
    cast: '成毅 / 曾舜晞',
    description: '闻名武林的四顾门门主李相夷，在一次大战后身受重伤，隐退江湖成为江湖游医。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20mystery%20drama%20poster%20style%2C%20lone%20swordsman%20silhouette%20against%20a%20full%20moon%20atop%20ancient%20rooftop%2C%20bamboo%20forest%20with%20mist%2C%20dramatic%20shadows%20and%20contrast%2C%20mysterious%20and%20atmospheric%2C%20ink%20wash%20painting%20style%20with%20subtle%20warm%20tones&width=400&height=560&seq=card-drama-03-lianhualou&orientation=portrait',
    badge: '口碑佳作',
  },
  {
    id: 4,
    title: '长相思',
    category: '上古神话',
    cast: '杨紫 / 张晚意',
    description: '上古时期，人神妖混居。皓翎王姬小夭流落大荒，历经百年颠沛，在清水镇落脚。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20mythological%20drama%20poster%20style%2C%20beautiful%20woman%20in%20flowing%20ancient%20dress%20standing%20in%20a%20field%20of%20red%20flowers%20under%20golden%20sunset%2C%20mythical%20phoenix%20silhouette%20in%20the%20sky%2C%20passionate%20and%20tragic%20atmosphere%2C%20rich%20red%20and%20gold%20color%20palette&width=400&height=560&seq=card-drama-04-changxiangsi&orientation=portrait',
    badge: '年度大剧',
  },
  {
    id: 5,
    title: '狂飙',
    category: '扫黑刑侦',
    cast: '张译 / 张颂文',
    description: '一线刑警安欣与鱼贩高启强，横跨二十年的黑白较量与复杂人性纠葛。',
    image: 'https://readdy.ai/api/search-image?query=Gritty%20Chinese%20crime%20drama%20poster%20style%2C%20two%20men%20facing%20each%20other%20in%20a%20rainy%20dark%20alley%20with%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20intense%20dramatic%20lighting%2C%20noir%20atmosphere%2C%20urban%20Chinese%20cityscape%20at%20night%2C%20gritty%20and%20powerful%20composition&width=400&height=560&seq=card-drama-05-kuangbiao&orientation=portrait',
    badge: '现象级',
  },
  {
    id: 6,
    title: '去有风的地方',
    category: '治愈田园',
    cast: '刘亦菲 / 李现',
    description: '都市白领许红豆辞职后前往大理云苗村，在田园生活中找到内心的平静与真爱。',
    image: 'https://readdy.ai/api/search-image?query=Healing%20Chinese%20slice%20of%20life%20drama%20poster%20style%2C%20couple%20walking%20through%20a%20field%20of%20wildflowers%20with%20distant%20mountains%20under%20blue%20sky%2C%20warm%20sunlight%2C%20rustic%20Yunnan%20village%20background%2C%20peaceful%20and%20gentle%20atmosphere%2C%20soft%20natural%20color%20palette%2C%20breezy%20and%20relaxing%20mood&width=400&height=560&seq=card-drama-06-youfeng&orientation=portrait',
    badge: '治愈首选',
  },
  {
    id: 7,
    title: '繁花',
    category: '年代商战',
    cast: '胡歌 / 马伊琍 / 唐嫣',
    description: '九十年代的上海，阿宝在改革开放浪潮中从普通青年成长为商界巨擘的传奇。',
    image: 'https://readdy.ai/api/search-image?query=Retro%20Chinese%20business%20drama%20poster%20style%2C%20stylish%20man%20in%201990s%20Shanghai%20suit%20standing%20on%20the%20Bund%20at%20night%20with%20neon%20lights%20and%20vintage%20cars%2C%20golden%20warm%20tones%2C%20nostalgic%20and%20luxurious%20atmosphere%2C%20classic%20Wong%20Kar%20Wai%20film%20aesthetic%2C%20rich%20amber%20and%20gold%20color%20palette&width=400&height=560&seq=card-drama-07-fanhua&orientation=portrait',
    badge: '神作必看',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            热门剧集
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精选全网热播电视剧，每一部都是值得追的好剧
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {dramaCards.map((drama) => (
            <a
              key={drama.id}
              href="#carousel"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-300/50"
            >
              <div className="relative aspect-[2/3] overflow-hidden">
                <img
                  src={drama.image}
                  alt={`${drama.title} - ${drama.category}电视剧在线观看`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).parentElement!.style.display = 'none';
                  }}
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-white">
                  {drama.badge}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
                  {drama.title}
                </h3>
                <p className="text-[11px] md:text-xs text-foreground-500 mb-1">{drama.category} · {drama.cast}</p>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{drama.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}